"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = require("../../../components/controls/checkbox/Checkbox.styled");
var _Icon = require("../../../components/media/icon/Icon");
var _Text = _interopRequireDefault(require("../../../components/text/Text"));
var _Label = _interopRequireDefault(require("../../../components/text/Label"));
var _utils = require("@react-aria/utils");
var _flex = require("../../../components/layout/flex");
var _FocusRing = require("../../../shared/utility-components/FocusRing");
var _jsxRuntime = require("react/jsx-runtime");
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    labelText = _ref.labelText,
    description = _ref.description,
    disabled = _ref.disabled,
    bgColor = _ref.bgColor,
    fgColor = _ref.fgColor,
    notBoldLabel = _ref.notBoldLabel,
    rest = _objectWithoutProperties(_ref, ["checked", "onChange", "labelText", "description", "disabled", "bgColor", "fgColor", "notBoldLabel"]);
  var id = (0, _utils.useId)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.StyledCheckboxContainer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flex.FlexColumn, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flex.FlexRow, {
        gap: "m",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusRing.FocusRing, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.StyledCheckBox, _objectSpread({
            id: id,
            "aria-label": 'Select row',
            checked: checked,
            onCheckedChange: onChange,
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            disabled: disabled,
            bgColor: bgColor
          }, rest, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Checkbox.StyledCheckBoxIndicator, {
              color: fgColor,
              children: [checked === 'indeterminate' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                color: 'white',
                icon: 'iconMinus'
              }), checked === true && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                newColor: disabled ? 'ondisabled' : 'ondark',
                icon: 'iconTick'
              })]
            })
          }))
        }), labelText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, {
          htmlFor: id,
          notBold: notBoldLabel,
          children: labelText
        })]
      }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.DescriptionWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: description
        })
      })]
    })
  });
};
var _default = exports.default = Checkbox;